import { render } from "./AddSchoolYear.vue?vue&type=template&id=24cd161e"
import script from "./AddSchoolYear.vue?vue&type=script&lang=js"
export * from "./AddSchoolYear.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__